import { Globe } from "@/components/Svg";
import CMultiSelect from "@/components/main/form/CMultiSelect";
import firebase_app from "@/lib/firebase/configs";
import { Loader } from "@mantine/core";
import { useDebouncedState } from "@mantine/hooks";
import { IconBoxMultiple } from "@tabler/icons-react";
import {
  addDoc,
  collection,
  endAt,
  getDocs,
  getFirestore,
  limit,
  orderBy,
  query,
  startAt,
} from "firebase/firestore";
import { useEffect, useState } from "react";

const SectorsInput = ({ dictionary, form, creatable = true }) => {
  const [sectors, setSectors] = useState([]);
  const [search, setSearch] = useDebouncedState("", 300);
  const [loading, setLoading] = useState(false);

  const createSector = async (name) => {
    try {
      const db = getFirestore(firebase_app);
      await addDoc(collection(db, "Sectors"), {
        name: name,
        lowerCaseName: name.toLowerCase(),
      });
    } catch (error) {}
  };

  const getSectors = async (search, inital = false) => {
    try {
      setLoading(true);
      const db = getFirestore(firebase_app);
      const q = inital
        ? query(collection(db, "Sectors"), orderBy("lowerCaseName"), limit(4))
        : query(
          collection(db, "Sectors"),
          orderBy("lowerCaseName"),
          startAt(search.toLowerCase()),
          endAt(search.toLowerCase() + "\uf8ff"),
          limit(4)
        );
      const querySnapshot = await getDocs(q);
      let sectorsQueried = [];
      querySnapshot.forEach((doc) => {
        const data = doc.data();
        sectorsQueried.push(data?.name);
      });
      setSectors(sectorsQueried);
      setLoading(false);
    } catch (error) {
      setLoading(false);
    }
  };

  useEffect(() => {
    getSectors("", true);
  }, []);

  useEffect(() => {
    if (search.length > 0) {
      getSectors(search);
    }
  }, [search]);

  return (
    <CMultiSelect
      data={
        form?.values?.sectors
          ? Array.from(new Set([...form?.values?.sectors, ...sectors]))
          : sectors
      }
      searchable
      creatable={creatable}
      placeholder={dictionary.sectors}
      className="mt-3"
      icon={<IconBoxMultiple />}
      limit={5}
      hoverOnSearchChange={true}
      onSearchChange={(query) => {
        setSearch(query);
      }}
      onCreate={(value) => {
        createSector(value);
        setSectors((data) => [...data, value]);
        form.setValues({
          sectors: [...form?.values?.sectors, value],
        });
      }}
      getCreateLabel={(query) => {
        return (
          <>
            <span className="text-primary">{dictionary.createItem}: </span>
            {query}
          </>
        );
      }}
      filter={(value, selected, item) => {
        return (
          item.value.toLowerCase().startsWith(value.toLowerCase()) && !selected
        );
      }}
      rightSection={loading && <Loader variant="oval" size={26} />}
      {...form.getInputProps("sectors")}
    />
  );
};

export default SectorsInput;
